import { useEffect } from "react";
import { useAddMemberModal } from "@circle-react/components/Modals/AddSpaceMember";
import type { Space } from "@circle-react/types";
import { Content } from "../Show/Content";

export interface InviteMemberProps {
  activeViewType?: string;
  isLockedSpace: boolean;
  space: Space;
  spaceResource: any;
}

export const InviteMember = ({ space, ...rest }: InviteMemberProps) => {
  const addMemberModal = useAddMemberModal();

  useEffect(() => {
    void addMemberModal.show({
      spaceId: space?.id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- avoid opening the modal multiple times on re-renders
  }, []);

  return <Content space={space} {...rest} />;
};
